module.exports = __webpack_public_path__ + "img/banner_copa_hapvida.e5942fba.jpeg";